/* Function */
import getImages from './getImages'

/* Types */
import { tProduct } from 'src/shared/frontendTypes/product'
import { imageSrc } from 'src/shared/frontendTypes/images'
import { selectedAttributes } from '../Components/AddToCart/Components/AttributesSelector'
import { discount, discountPrice } from 'src/shared/frontendTypes/product'
import { priceLock } from 'src/shared/frontendTypes/warenkorb'

export type combination = {
  key: string
  attributes: string[]
  price: number | discountPrice
  options?: number[]
  deliverytime: number
  stockDeliverytime?: number
  images: imageSrc[]
  stock?: number
  discount?: discount
  priceLock?: priceLock
  hash: string
}

const getCombination = (
  product: tProduct,
  selectedAttributes: selectedAttributes
): combination | null => {

  const { combinations } = product

  const selectedOptions = Object.values(selectedAttributes).filter(
    (o): o is number => typeof o === 'number'
  )

  const combination = combinations
  .filter(c =>
    c.cultivable !== false &&
    selectedOptions.every(o => c.options.includes(o))
  )
  .sort((a,b)=>a.price-b.price) // Günstigste Kombination zuerst
  [0]

  if (!combination) return null

  const {
    key, price, options, attributes, deliverytime, stockDeliverytime,
    stock, discount, priceLock, hash,
  } = combination

  const images = getImages(product, combination, selectedOptions)

  return {
    key,
    attributes,
    price: discount
      ? {
        regularPrice:  price,
        discountPrice: discount.price,
        discountPriceAfterStock: discount.priceAfterStock,
        stockDiscountLimit: discount.stockDiscountLimit,
        limitStockDiscountToStock: discount.limitStockDiscountToStock,
        quantityDiscount: discount.quantityDiscount,
        title:         discount.metaTitle,
        type:          discount.type,
        countdownVariant: discount.countdownVariant,
        dateEnd:       discount.dateEnd,
        showPercent:   discount.showPercent,
      } 
      : price
    ,
    options,
    deliverytime,
    stockDeliverytime,
    images,
    stock,
    discount,
    priceLock,
    hash,
  }

}

export default getCombination
